import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Constants } from 'src/app/_consts/constants';
import { STableComponent } from '../../comps/s-table/s-table.component';

@Component({
  selector: 'app-news-modal',
  templateUrl: './news-modal.component.html',
  imports: [TranslateModule, STableComponent]
})
export class NewsModalComponent implements OnInit {
  
  public cols = Constants.NEWS_COLS
  public refreshUrl = "getNews"

  constructor() { }

  ngOnInit(): void {
  }

}
